/**
 * The wire contract between the portal API and the web client.
 *
 * Both sides import these types, so a change that breaks one breaks the other at compile time
 * rather than at 2am in front of a customer.
 *
 * PRIVACY RULES BAKED INTO THE SHAPE
 * ----------------------------------
 *  - There is no field anywhere here that can carry a jotform.com URL. Documents carry an opaque
 *    id and a portal-relative path; the real upload URL never leaves the server, because those
 *    URLs are anonymously downloadable with no login, no token and no expiry.
 *  - The emergency contact is NOT part of the dog payload. It is a separate, explicitly-requested
 *    endpoint, because those ~156 people never filled in a form and never saw a privacy notice.
 *    Every reveal is audited.
 */
export const API_ROUTES = {
    signIn: '/api/auth/sign-in',
    consume: '/api/auth/consume',
    signOut: '/api/auth/sign-out',
    session: '/api/auth/session',
    me: '/api/me',
    foodEditValues: (dogId) => `/api/food/${dogId}/edit`,
    foodEdit: '/api/food/edit',
    emergencyContact: (dogId) => `/api/dogs/${dogId}/emergency-contact`,
    markGiven: '/api/care/mark-given',
    file: (fileId) => `/api/files/${fileId}`,
    health: '/api/health',
    staffSignIn: '/api/staff/sign-in',
    staffConsume: '/api/staff/consume',
    staffSignOut: '/api/staff/sign-out',
    staffSession: '/api/staff/session',
    staffDogs: '/api/staff/dogs',
    staffHousehold: (customerId) => `/api/staff/households/${customerId}`,
    /** Super Administration Zone. Every one of these requires role 'super'. */
    adminPinSignIn: '/api/admin/sign-in',
    adminOperations: '/api/admin/operations',
    adminAudit: '/api/admin/audit',
    adminStaff: '/api/admin/staff',
    adminAllowlist: '/api/admin/allowlist',
    adminSync: '/api/admin/sync',
    adminMealLinks: '/api/admin/meal-links',
    adminMealLinkConfirm: '/api/admin/meal-links/confirm',
    adminMealLinkNoMatch: '/api/admin/meal-links/no-match',
    adminMealLinkEdit: '/api/admin/meal-links/edit',
    adminEmergencyContact: (dogId) => `/api/admin/dogs/${dogId}/emergency-contact`,
};
//# sourceMappingURL=api.js.map